<template>
    <footer class="page-footer">
        <footer-contact v-if="! isSberbank"/>
        <footer-menu/>
        <cookie-confirm/>
    </footer>
</template>

<script>
    import FooterContact from '~/components/footer/FooterContact.vue'
    import CookieConfirm from '~/components/footer/CookieConfirm.vue'
    import FooterMenu from '~/components/footer/FooterMenu.vue'

    export default {
        components: {
            FooterContact,
            FooterMenu,
            CookieConfirm
        },
        computed: {
            isSberbank() {
                return ($nuxt.$route.path.indexOf('sberbank') !== -1);
            }
        },
    }
</script>

<style lang="scss" scoped>
    .page-footer {
        position: relative;
        z-index: 20;
    }
</style>



// WEBPACK FOOTER //
// components/footer/PageFooter.vue